module.exports = __webpack_public_path__ + "img/logo-mo-37.94276532.svg";